export default __webpack_public_path__ + "static/media/Killerface_pfp.55ca0276.png";